import AbstractEditWidget from "cluetrainer/ui/widgets/AbstractEditWidget";
import jquery from "jquery";
export default class TextArea extends AbstractEditWidget {
    constructor(customization = {}) {
        super(jquery("<textarea class='nisl-textinput'>"));
        this.raw().readOnly = !!customization.readonly;
        this.raw().placeholder = customization.placeholder || "";
        this
            .on("input", () => {
            this.preview(this.container.val());
        })
            .on("change", () => {
            this.commit(this.container.val());
        });
    }
    setEnabled(v) {
        this.container.prop("disabled", !v);
        return this;
    }
    setPlaceholder(placeholder) {
        this.container.attr("placeholder", placeholder);
        return this;
    }
    render() {
        this.container.val(this.get());
    }
}
